import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

type Props = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

export default function ResetAuthenticatorDialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={() => onClose(false)}>
      <DialogTitle>Reset Authenticator</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={styles.title}>
          This will generate a new secret key.
        </Typography>
        <Typography variant="body2">
          After resetting, your existing authenticator app codes will stop working. You will need to
          scan a new QR code and enable 2FA again. Make sure you have access to your device before proceeding.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(true)} color="primary" variant="contained">
          Reset Key
        </Button>
        <Button onClick={() => onClose(false)} color="inherit" variant="text">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  title: {
    fontWeight: 600,
    mb: 1
  }
};
